import HoverIconSwitch from "@/components/checkout/HoverIconSwitch"
import DeleteHover from '@/svgs/checkout/delete-hover.svg'
import DeleteIcon from '@/svgs/checkout/delete.svg'
import WishListHover from '@/svgs/checkout/My-Wishlist-hover.svg'
import WishListIcon from '@/svgs/checkout/My-Wishlist.svg'
import styles from "@/styles/view-cart.module.scss"

interface CartBulkActionsProps {
  selectedCount: number
  onDelete: () => void
  onMoveToWishlist: () => void
}

const CartBulkActions = ({ selectedCount, onDelete, onMoveToWishlist }: CartBulkActionsProps) => (
  <div className={styles['batch-box']}>
    <div className={styles['selected']}><span style={{ color: "#D70B17", fontWeight: 'bold' }}>{selectedCount}</span>&nbsp;items&nbsp;selected</div>

    <HoverIconSwitch
      IconOne={<DeleteIcon className={styles['cart-icon']} onClick={onDelete} />}
      IconTwo={<DeleteHover className={styles['cart-icon']} onClick={onDelete} />}
      hoverContent="Delete"
    />
    <HoverIconSwitch
      IconOne={<WishListIcon className={styles['cart-icon']} onClick={onMoveToWishlist} />}
      IconTwo={<WishListHover className={styles['cart-icon']} onClick={onMoveToWishlist} />}
      hoverContent="Move to wishlist"
    />
  </div>
)

export default CartBulkActions
